<template>
  <button
    v-if="location"
    class="base-location"
    :class="{ compact }"
    @click.stop="openLocation(location, null)"
  >
    <span class="icon"><InlineLocationIcon /></span>
    <span class="location">{{ location }}</span>
  </button>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import InlineLocationIcon from "@/components/icons/InlineLocationIcon.vue";
import { openLocation } from "@/event";

export default defineComponent({
  components: { InlineLocationIcon },
  props: {
    location: {
      type: String,
      required: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return { openLocation };
  },
});
</script>
<style scoped lang="scss">
.base-location {
  display: flex;
  flex-direction: row;
  align-items: center;
  @extend %font-caption-medium;
  column-gap: 6px;
  padding: 2px 8px;
  border-radius: 50px;
  overflow: hidden;
  @include themed() {
    background-color: t($grey-05);
    color: t($tertiary-50);
  }
  :deep(svg) {
    .fill {
      @include themed() {
        fill: t($tertiary-50);
      }
    }
    .stroke {
      @include themed() {
        stroke: t($tertiary-50);
      }
    }
  }
  &:hover {
    @include themed() {
      background-color: t($bg-hover-location);
    }
  }
  .location {
    @extend %font-caption-regular;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &.compact {
    padding: 0 6px;
  }
}
</style>
